<p>json-view-page works!</p>
